import { render, staticRenderFns } from "./ResearchSimpleScatterPlot.vue?vue&type=template&id=0ad4c01a&"
import script from "./ResearchSimpleScatterPlot.vue?vue&type=script&lang=js&"
export * from "./ResearchSimpleScatterPlot.vue?vue&type=script&lang=js&"
import style0 from "./ResearchSimpleScatterPlot.vue?vue&type=style&index=0&id=0ad4c01a&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad4c01a')) {
      api.createRecord('0ad4c01a', component.options)
    } else {
      api.reload('0ad4c01a', component.options)
    }
    module.hot.accept("./ResearchSimpleScatterPlot.vue?vue&type=template&id=0ad4c01a&", function () {
      api.rerender('0ad4c01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSimpleScatterPlot.vue"
export default component.exports